import { ButtonSelect } from '../../../Select'

function EpostFormFieldsEnvelopeSelect(props) {
  return (
    <ButtonSelect
      {...props}
      controlProps={{
        borderless: true,
        indicatorsProps: {
          ButtonClear: null,
        },
      }}
    />
  )
}

export default EpostFormFieldsEnvelopeSelect
